module.exports = __webpack_public_path__ + "static/media/individual.d9cbe807.svg";